import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../UserContext'; // Importa il contesto
import { useNavigate } from 'react-router-dom';
import Notifiche from "./Notifiche";
function Testata() {
  const navigate = useNavigate();
  const { userData } = useContext(UserContext); // Ottieni userData dal contesto
  // Stato per i dati dell'utente nel componente
  const [imageExists, setImageExists] = useState(true); // Inizia assumendo che l'immagine esista
  const [displayedUserData, setDisplayedUserData] = useState(userData);
  // const [conta, setConta] = useState(true);  

  // useEffect(() => {   
  //   const fetchUtenti = async () => {
  //     const token = localStorage.getItem('token');
  //       try {
  //           const response = await fetch(`/api/counter`, {
  //           headers: {
  //               'Authorization': `Bearer ${token}`,
  //               'Content-Type': 'application/json'
  //           },
  //           credentials: 'include'
  //           });

  //           if (response.ok) {
  //             const conta = await response.json();
  //             const totale = conta[0].totale;
  //             setConta(totale); // Aggiorna lo stato con i documenti ricevuti
  //           } else {
  //             setConta(0);
  //           }
  //       } catch (err) {
  //           setConta(0);
  //       }
  //   };

  //   fetchUtenti(); 
  // }, []);// Chiama la funzione per recuperare gli Utenti   

  useEffect(() => {    
      
  }, [userData]);

  useEffect(() => {
    setImageExists(false); // Se l'immagine non si carica, imposta imageExists a false
  }, [userData?.item]); // Dipendenza da userData.item per ricaricare se cambia l'utente

  const circleStyle = {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#b19DC9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '24px', // Regola la dimensione del font delle iniziali
    fontWeight: 'bold',
  };

  useEffect(() => {
    // Aggiorna i dati visualizzati solo se userData cambia
    setDisplayedUserData(userData);
  }, [userData]);
  
  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token'); 
    setDisplayedUserData(userData);
    navigate('/');
  };
  return (
    <div className="row">
      <div className="col-lg-12 p-0">
        <div className="header_iner d-flex justify-content-between align-items-center">
          <div className="logo" style={{width: "180px"}}>
                <a href="/dashboard"><img src="/img/ilNecrologio_info.svg" alt="ilNecrologio.info" style={{width: "150px"}} /></a>
            </div>
          <div className="serach_field-area">
            
            <h6>Area Riservata di:</h6>
            {displayedUserData && displayedUserData.ragSociale ? (
              <>
                <h4 style={{color: '#b19dc9'}}>{displayedUserData && displayedUserData.ragSociale}</h4>
              </>
            ) : (
              <>
                <h4 style={{color: '#b19dc9'}}>{displayedUserData && displayedUserData.nome} {displayedUserData && displayedUserData.cognome}</h4>
              </>
            )}
            {/* Sinora hai pubblicato: <b style={{color: '#b19dc9'}}>{conta}</b> volte */}
          </div>
          <div className="header_right d-flex justify-content-between align-items-center">
            <div className="header_notification_warp d-flex align-items-center">
              {displayedUserData && displayedUserData.role === "user" && <Notifiche />} {/* Rendering condizionale di Notifiche */}
            </div>
            <div className="profile_info">              
              <div style={circleStyle}><i className="ti-menu"></i></div>
              <div className="profile_info_iner">
                <p className="text-white" style={{fontSize: "1.2rem"}}>
                  Ciao {displayedUserData && displayedUserData.nome}!
                </p>
                {/* <h5>{userData && userData.utente}</h5> */}
                <div className="profile_info_details">                                
                      <a href="/dashboard">
                        Home <i className="ti-home"></i>
                      </a>              
                      <a href="/nuovo-annuncio">
                        Nuovo annuncio <i className="ti-plus"></i>
                      </a>
                      <a href="/nuovo-allegato">
                        Nuovo allegato <i className="ti-plus"></i>
                      </a>
                      <a href="/profilo">
                        Il tuo profilo <i className="ti-user"></i>
                      </a>
                      <a href="/cambio-password">
                        Cambia password <i className="ti-unlock"></i>
                      </a>
                  <hr />
                  <a href="#!" onClick={handleLogout}>
                    Uscita <i className="ti-shift-right text text-danger"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testata;
